import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { minPurchasePrime } from 'config'
import { useViewportMediaQuery } from 'hooks'
import Loader from 'components/Loader'
import Price from 'components/Price'
import SecondaryCartButtons from 'components/NewCart/SecondaryCartButtons'
import CencoPrime from './CencoPrime'
import StorageService from 'services/StorageService/'
import CmsService from 'services/CMS'
import style from './style.scss' //NOSONAR
import PubSub from 'services/PubSub'
import { actionsType } from 'config/constants'

let actions = [];

const CartControls = (props) => {
    const { orderForm, buttonPurchase, disabledOptions, isCatPayment, submitLoading } = props
    const [minPurchase, setMinPurchase] = useState(0)
    const [primePurchase, setPrimePurchase] = useState(0)
    const [primePurchaseCat, setPrimePurchaseCat] = useState(0)
    const [isLoading, setLoader] = useState(false)
    const [checkoutIsReady, setCheckoutIsReady] = useState(disabledOptions ? disabledOptions.submit : false)

    useEffect(() => {

        actions.push(PubSub.register(actionsType.TOTALIZER_LOADER, enableLoader));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    },[])

    const enableLoader = (payload) => {
        setLoader(payload.value.loader)
    }

    const isMobile = useViewportMediaQuery(1024)
    const { disableGoBack } = props.disabledOptions
    const submitBack = props.submitBack ? props.submitBack : () => {}
    const isTerms = !(disabledOptions && disabledOptions.terms)
    const maxPrice = disabledOptions && disabledOptions.maxPrice
    const submitIsReady = !maxPrice && (isTerms || checkoutIsReady)
    const textMinAmount = buttonPurchase ? (
        <>
            <strong>Recuerda </strong> que el monto mínimo de compra es
        </>
    ) : (
        'Monto mínimo de compra'
    )

    useEffect(() => {
        if (orderForm) {
            CmsService.getOperationsV2().then((data) => {
                if (data && data.config_purchase) {
                    let configPurchase = data.config_purchase.minimum_purchase ? data.config_purchase.minimum_purchase * 1 : 0
                    let marginTCenco = data.config_purchase.margin_tcenco ? (data.config_purchase.margin_tcenco * 1) / 100 : 0

                    if (isCatPayment && marginTCenco) {
                        configPurchase = configPurchase * (1 - marginTCenco)
                    }

                    const shipping = orderForm.totalizers.find((item) => {
                        return item.id === 'Shipping'
                    })

                    const totalOrderForm = (orderForm.value - (shipping ? shipping.value : 0)) / 100

                    minimunPurchase(configPurchase, totalOrderForm)
                    purchasePrime(totalOrderForm)
                }
            })
        }
    }, [orderForm])

    useEffect(() => {
        if (disabledOptions) {
            setCheckoutIsReady(disabledOptions.submit)
        }
    }, [disabledOptions])

    const minimunPurchase = (configPurchase, totalOrderForm) => {
        const minPurchases = configPurchase * 1

        if (configPurchase > totalOrderForm) {
            setMinPurchase(minPurchases)
        } else {
            setMinPurchase(null)
        }
    }

    const purchasePrime = (totalOrderForm) => {
        const dataUser = StorageService.getSecureItem('userData')
        const cencoPrime = dataUser && dataUser.CencoPrime_2020 ? dataUser.CencoPrime_2020 : ''

        setPrimePurchase(!!cencoPrime && minPurchasePrime > totalOrderForm)

        const cencoPrimeCat = dataUser && dataUser.CencoPrime_CAT ? dataUser.CencoPrime_CAT : ''
        setPrimePurchaseCat(!!cencoPrimeCat && minPurchasePrime > totalOrderForm)
    }

    const readyToCheckout = submitIsReady && !minPurchase && disabledOptions.submit


    return (
        <>
            <div className="new-cart-button-container">
                {!!minPurchase && (
                    <span className="minimum-alert">
                        {textMinAmount} <strong><Price price={minPurchase} /></strong>
                    </span>
                )}
                {!!(primePurchase || primePurchaseCat) && <CencoPrime primeCat={primePurchaseCat} />}
                <div className="cart-button-cont-btn">
                    {!disableGoBack && (
                        <button className="secundary-btn" onClick={() => submitBack()}>
                            Volver
                        </button>
                    )}
                    <button
                        className={`primary-btn cart-button-order-submit ${disableGoBack && 'only-continue'} ${readyToCheckout ? 'active' : ' disabled-btn'}`}
                        onClick={(submitLoading || isLoading) ? () => {} : () => props.submitOrder(readyToCheckout)}>
                        {(submitLoading || isLoading) ? <Loader /> : buttonPurchase ? 'Pagar' : 'Continuar'}
                    </button>
                </div>
            </div>
            {!isMobile && (
                <SecondaryCartButtons orderForm={orderForm} />
            )}
        </>
    )
}

CartControls.propTypes = {
    history: PropTypes.object,
    orderForm: PropTypes.object,
    match: PropTypes.object,
    disabled: PropTypes.object,
    submitLoading: PropTypes.bool,
    buttonPurchase: PropTypes.bool,
    submitOrder: PropTypes.func,
    submitBack: PropTypes.func,
    isCatPayment: PropTypes.bool,
}

export default withRouter(CartControls)
